export const ButtonGroupWidgetId = 'ButtonGroupWidget';

export enum ButtonGroupWidgetAttributes {
  BUTTONS = 'buttons',
}
